<template>
    <div>
      <loading :active.sync="loader.isLoading" :can-cancel="loader.canCancel" :is-full-page="loader.fullPage" :color="loader.color" :height="loader.height" :width="loader.width" :background-color="loader.backgroundColor" :loader="loader.loader"></loading>
      <div class="row">
        <div class="col-md-12">
          <div class="top-list-toolbar">
            <div>
              <h4 class="text-primary" @click="backParent">Sales Unit</h4>
              <ol class="breadcrumb breadcrumb-card-header">
                <li class="breadcrumb-item">
                  <a href="javascript:void(0);" @click="backParent">Sales</a>
                </li>
                <li class="breadcrumb-item active">
                  <span v-if="sales.id === null">New</span>
                  <span v-else>{{ sales.sale_no }}</span>
                </li>
              </ol>
              <button class="btn btn-success btn-sm pull-left dropdown-toggle" type="button" id="printsales" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" v-show="sales.sale_no !== null">Action</button>
              <div class="dropdown-menu" aria-labelledby="printsales">
                <a class="dropdown-item" href="javascript:void(0)" @click="print">Print Invoice</a>
                <a class="dropdown-item" href="javascript:void(0)" @click="printInvoice('bstk')">Print BSTK</a>
                <a class="dropdown-item" href="javascript:void(0)" data-toggle="modal" data-target="#modalRequestEdit" data-backdrop="static" data-keyboard="false">Request Edit</a>
                <a class="dropdown-item" href="javascript:void(0)" data-toggle="modal" data-target="#modalRequestVoid" data-backdrop="static" data-keyboard="false">Request Delete</a>
                <a class="dropdown-item" href="javascript:void(0)" @click="setJournalSingle">Journal Invoice</a>
                <!-- <a class="dropdown-item" href="javascript:void(0)" @click="setJournalPaymentSingle">Journal Payment</a> -->
                <a class="dropdown-item" href="javascript:void(0)" @click="setJournalStockSingle">Journal Stock Out</a>
                <a class="dropdown-item" href="javascript:void(0)" @click="setJournalReturn">Journal Return</a>
                <a class="dropdown-item" href="javascript:void(0)" @click="setJournalAll">Journal All</a>
                <a href="javascript:void(0)" class="dropdown-item" @click="syncOrderAll('reply')">Sync Order ALl</a>
                <a href="javascript:void(0)" class="dropdown-item" @click="syncOrder2('reply')">Sync Order New</a>
                <a href="javascript:void(0)" class="dropdown-item" @click="setCOGSAll('reply')">Sync COGS</a>
                <a href="javascript:void(0)" class="dropdown-item" @click="removeSales">Delete</a>
                <a href="javascript:void(0)" class="dropdown-item" @click="unlock">Unlock</a>
              </div>
              <!-- <button type="button" @click="createBastk" class="btn btn-sm btn-info pull-left" v-show="sales.sale_no !== null"><i class="fa fa-barcode"></i>BASTK</button> -->
              <!-- <button type="button" class="btn btn-sm btn-primary pull-right" data-toggle="modal" data-target="#modalProjectSale" data-backdrop="static" data-keyboard="false" v-if="sales.sale_no !== null">Create Project</button> -->
              <button type="button" @click="updateSales" class="btn btn-sm btn-soft-primary pull-left" v-show="sales.sale_no !== null && sales.lock === false"><i class="fa fa-save" aria-hidden="true"></i> Update</button>
              <button type="button" @click="createSales" class="btn btn-sm btn-soft-primary pull-left" v-show="sales.sale_no == null"><i class="fa fa-check" aria-hidden="true"></i> Create</button>
              <button type="button" @click="approveAll" class="btn btn-sm btn-soft-primary pull-left" v-show="sales.sale_no !== null && sales.lock === false"><i class="fa fa-check" aria-hidden="true"></i> Approve</button>
              <button type="button" @click="validateDetailProduct" class="btn btn-sm btn-soft-primary pull-left"><i class="fa fa-check" aria-hidden="true"></i> Validate</button>
              <!-- <button type="button" @click="salesPayment" class="btn btn-sm btn-success pull-right" v-show="sales.sale_no !== null"><i class="fa fa-money"></i> Payment</button> -->
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div :class="card1">
          <div class="card card-list">
            <div class="card-header">
              <h5 v-if="sales.sale_no === null">New</h5>
              <h5 v-else>
                {{ sales.sale_no }}
                <span class="badge badge-warning" v-if="sales.status === 'outstanding'">{{ sales.status }}</span>
                <span class="badge badge-primary" v-else>{{ sales.status }}</span>
              </h5>
            </div>
            <div class="card-body">
              <div class="alert alert-danger alert-dismissible fade show" role="alert" v-if="alert.length > 0">
                <ul v-for="(a, index) in alert" :key="index">
                  <li v-html="a"></li>
                </ul>
              </div>
              <div class="row">
                  <div class="col-md-4">
                    <dl class="row dl-custom font-12">
                      <dt class="col-md-4">Customer</dt>
                      <dd class="col-md-8">
                        <button type="button" data-toggle="modal" data-target="#modalCustomerForm" data-backdrop="static" data-keyboard="false"  class="btn btn-sm btn-hard-primary mr-1" :disabled="sales.lock">+ New</button>
                        <button type="button" data-toggle="modal" data-target="#modalCustomerList" data-backdrop="static" data-keyboard="false"  class="btn btn-sm btn-hard-primary" @click="getCustomerList" :disabled="sales.lock">List</button>
                        <button type="button" class="btn btn-sm btn-hard-primary ml-1" @click="getCustomerOrder" :disabled="sales.lock">Get Order</button>
                      </dd>
                      <dt class="col-md-4">Customer No</dt>
                      <dd class="col-md-8">{{ sales.customer_no }}</dd>
                      <dt class="col-md-4">Name</dt>
                      <dd class="col-md-8">{{ sales.customer.name }}</dd>
                      <dt class="col-md-4">Phone</dt>
                      <dd class="col-md-8">{{ sales.customer.phone }}</dd>
                      <dt class="col-md-4">Address</dt>
                      <dd class="col-md-8">{{ sales.customer.address }}</dd>
                    </dl>
                    <dl class="row dl-custom font-12">
                      <dt class="col-md-4">Tgl. Sales</dt>
                      <dd class="col-md-8"><!-- <span v-if="sales.lock">{{ sales.sale_date | dateFormat('DD/MM/YYYY') }}</span> -->
                        <datetime v-model="sales.sale_date" format="dd/MM/yyyy" class="form-control" value-zone="local" zone="local" v-if="authUser.permissions.sale_backdate"></datetime>
                        <datetime v-model="sales.sale_date" format="dd/MM/yyyy" class="form-control" value-zone="local" zone="local" v-else :disabled="sales.lock"></datetime>
                      </dd>

                      <dt class="col-md-4">Jatuh Tempo</dt>
                      <dd class="col-md-8">
                        <select v-model="sales.term_due_id" class="form-control form-control-lite" :disabled="sales.lock">
                          <option v-for="t in termDueList" :key="t.id" :value="t.id">{{ t.name }}</option>
                          <option value=""><i>Custom</i></option>
                        </select>
                      </dd>
                      <dt class="col-md-4"></dt>
                      <dd class="col-md-8">
                        <span v-if="sales.lock">{{ sales.sale_due_date | dateFormat('DD/MM/YYYY') }}</span>
                      </dd>
                    </dl>
                  </div>
                  <div class="col-md-4">
                    <dl class="row dl-custom">
                      <dt class="col-md-4">Type</dt>
                      <dd class="col-md-8">
                        <select class="form-control form-control-lite" v-model="sales.type_id" :disabled="sales.lock" @change="setTypeSales">
                          <option v-for="t in salesTypeList" :key="t.id" :value="t.id">{{ t.name }}</option>
                        </select>
                      </dd>
                      <dt class="col-md-4">Company</dt>
                      <dd class="col-md-8">
                        <select v-model="sales.company_no" class="form-control form-control-lite" @change="checkTax" :disabled="sales.lock || sales.sale_no !== null">
                          <option v-for="c in companyList" :key="c.id" :value="c.company_no">{{ c.name }}</option>
                        </select>
                      </dd>
                      <dt class="col-md-4">Tax</dt>
                      <dd class="col-md-8">
                        <select v-model="sales.tax_id" class="form-control form-control-lite" @change="setTax" :disabled="sales.lock">
                          <option v-for="t in taxList" :key="t.id" :value="t.id">Tax: {{ t.name }}</option>
                        </select>
                      </dd>
                      <!-- <dt class="col-md-4">Price List</dt>
                      <dd class="col-md-8">
                        <select v-model="sales.price_id" class="form-control form-control-lite" :disabled="sales.lock">
                          <option value="">-- Price List --</option>
                          <option v-for="p in priceListGroup" :key="p.id" :value="p.id">{{ p.name }}</option>
                        </select>
                      </dd> -->
                    </dl>
                  </div>
                  <div class="col-md-4">
                    <strong class="font-14">Orders:</strong>
                    <span class="ml-2 font-16" style="cursor: pointer; color: #6FB56F" data-toggle="modal" data-target="#modalSalesOrderList" data-backdrop="static" data-keyboard="false" @click="getCustomerOrderList"><i class="fa fa-pencil"></i></span>
                    <span class="ml-2 font-16">
                    </span>
                    <ul v-for="(p, index) in sales.orders" :key="p.id">
                      <li>
                        <span style="cursor: pointer; color: blue;" @click="getOrderNo(p.order_no)" data-toggle="modal" data-target="#modalSaleOrderByNo" data-backdrop="static" data-keyboard="false">
                          {{ p.project_name }}
                        </span>
                        - {{ p.order_date | dateFormat('DD/MM/YYYY') }}
                        - <i>{{ p.order_no }}</i>
                        <span class="ml-2 font-16" style="color: red; cursor: pointer" @click="removeOrder(index)" v-if="sales.lock !== true"><i class="fa fa-trash-o" aria-hidden="true"></i></span>
                      </li>
                    </ul>
                    <hr>
                    <dl class="row dl-custom">
                      <dt class="col-md-4">Notes</dt>
                      <dd class="col-md-8">
                        <textarea v-model="sales.notes" class="form-control" rows="3" :disabled="sales.lock"></textarea>
                      </dd>
                    </dl>
                  </div>
              </div>
              <div class="row">
                <div class="col-md-12">
                    <ul class="nav nav-tabs nav-bordered">
                      <li class="nav-item">
                        <a href="#unit-sales" data-toggle="tab" aria-expanded="false" class="nav-link active"><i class="fa fa-search"></i> Unit</a>
                      </li>
                      <li class="nav-item">
                        <a href="#general" data-toggle="tab" aria-expanded="false" class="nav-link">Sales</a>
                      </li>
                      <li class="nav-item">
                        <a href="#summary" data-toggle="tab" aria-expanded="false" class="nav-link">Summary</a>
                      </li>
                      <li class="nav-item">
                        <a href="#payment" data-toggle="tab" aria-expanded="false" class="nav-link">Payment</a>
                      </li>
                      <li class="nav-item">
                        <a href="#journal" data-toggle="tab" aria-expanded="false" class="nav-link">
                          Journal
                        </a>
                      </li>
                      <li class="nav-item">
                        <a href="#deliver" data-toggle="tab" aria-expanded="false" class="nav-link">Stock Out</a>
                      </li>
                    </ul>
                    <div class="tab-content">
                      <div class="tab-pane active" id="unit-sales">
                        <div class="row">
                          <div class="col-md-12">
                            <div class="table-responsive">
                              <button type="button" class="btn btn-sm btn-soft-primary" @click="getUnitList"  data-toggle="modal" data-target="#modalUnit" data-backdrop="static" data-keyboard="false">Unit</button>
                              <table class="table table-sm table-item table-striped">
                                <thead>
                                  <th>Unit No.</th>
                                  <th>Date</th>
                                  <th>Type</th>
                                  <th>Schedule Date</th>
                                  <th>Start Date</th>
                                  <th>Finish Date</th>
                                  <th>Internal Number</th>
                                  <th>Fuel Total</th>
                                  <th>#</th>
                                </thead>
                                <tbody>
                                  <tr v-for="(u, index) in sales.units" :key="index">
                                    <td>{{ u.unit_no }}</td>
                                    <td>{{ u.unit_date | dateFormat('DD/MM/YYYY') }}</td>
                                    <td>{{ u.type_id }}</td>
                                    <td>{{ u.schedule_date | dateFormat('DD/MM/YYYY') }}</td>
                                    <td>{{ u.start_date | dateFormat('DD/MM/YYYY') }}</td>
                                    <td>{{ u.finish_date | dateFormat('DD/MM/YYYY') }}</td>
                                    <td></td>
                                    <td>{{ u.fuel_total }} {{ u.fuel_uom }}</td>
                                    <td>
                                      <button type="button" class="btn btn-sm btn-soft-outline-danger" @click="removeUnit(index)"><i class="fa fa-trash"></i></button>
                                    </td>
                                  </tr>
                                </tbody>
                              </table>
                            </div>
                            <pre>{{ sales.units }}</pre>
                          </div>
                        </div>
                      </div>
                      <div class="tab-pane" id="general">
                        <div class="row">
                          <div class="col-md-12">
                            <div class="table-responsive">
                              <table class="table table-sm table-item table-striped">
                                <thead>
                                  <th>Product</th>
                                  <th>Description</th>
                                  <th>Order No.</th>
                                  <th>Qty</th>
                                  <th style="width: 10%">Uom</th>
                                  <th class="text-right">Price</th>
                                  <th class="text-right">Discount</th>
                                  <th class="text-right">%</th>
                                  <th class="text-right">Subtotal(DPP)</th>
                                  <th class="text-right">Tax /item</th>
                                  <th class="text-right">Total</th>
                                  <th style="width: 10%">#</th>
                                </thead>
                                <tbody>
                                  <tr v-for="(d, index) in getDataDetails" :key="d.id">
                                    <td>
                                      <p class="input-group">
                                        <input type="text" class="form-control" v-model="d.product_no" disabled="disabled" />
                                        <span class="input-group-btn ml-1">
                                          <button data-toggle="modal" data-target="#modalGetProduct" data-backdrop="static" data-keyboard="false" type="button" class="btn btn-outline-primary btn-sm" @click="setIdDetail(index)" :disabled="sales.lock">
                                            <i class="fa fa-search" aria-hidden="true"></i>
                                          </button>
                                        </span>
                                      </p>
                                    </td>
                                    <td>{{ d.description }}</td>
                                    <td>{{ d.order_no }}</td>
                                    <td><input type="text" class="form-control" v-model="d.qty" v-on:keyup="calcRow(index)"/></td>
                                    <td>
                                      <select v-model="d.uom_id" class="form-control" @change="uomRow(index)" disabled="disabled">
                                        <option v-for="u in d.uomList" :value="u.id" :key="u.id">{{ u.name }}</option>
                                      </select>
                                    </td>
                                    <td><input type="text" class="form-control form-control-right" v-model="d.price" v-money="money" v-on:keyup="calcRow(index)" disabled="disabled"/></td>
                                    <td class="text-right">{{ d.discount | currency }}</td>
                                    <td>
                                      <input type="text" class="form-control form-control-right" v-model="d.discount_percentage" v-on:keyup="calcRow(index)" :disabled="d.lock"/>
                                    </td>
                                    <td class="text-right">{{ d.subtotal | currency }}</td>
                                    <td class="text-right form-table-label">{{ d.tax | currency }}</td>
                                    <td class="text-right form-table-label">
                                      <span>{{ d.total | currency }}</span> &nbsp;
                                    </td>
                                    <td>
                                      <button type="button" class="btn btn-sm btn-soft-outline-danger" @click="removeDetail(index)" :disabled="d.lock"><i class="fa fa-trash"></i></button>
                                      <!-- <button type="button" class="btn btn-sm btn-hard-primary" @click="selectProductToOrder(d.product_no)">
                                        <i class="fa fa-share" aria-hidden="true"></i>
                                      </button> -->
                                      <button type="button" class="btn btn-sm btn-info" @click="moveUp(index)">
                                        <i class="fa fa-arrow-circle-up" aria-hidden="true"></i>
                                      </button>
                                      <button type="button" class="btn btn-sm btn-info" @click="moveDown(index)">
                                        <i class="fa fa-arrow-circle-down" aria-hidden="true"></i>
                                      </button>
                                    </td>
                                  </tr>
                                </tbody>
                                <tfoot>
                                  <tr>
                                    <td>
                                      <span v-show="authUser.permissions.sale_add_product_line">
                                        <span @click="addNewLine" class="link-secondary" v-if="sales.lock === false">+ Add Product</span>
                                      </span>
                                    </td>
                                    <td><span @click="refreshCalc" class="link-secondary" v-if="sales.lock === false">Refresh Total</span></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td class="text-right"><i>{{ getTotalPrice | currency }}</i></td>
                                    <td class="text-right">{{ getTotalDiscount | currency }}</td>
                                    <td></td>
                                    <td></td>
                                    <td class="text-right">{{ getTotalTaxDetail | currency }}</td>
                                    <td class="text-right"></td>
                                    <td></td>
                                  </tr>
                                  <tr>
                                    <td colspan="10" class="text-right"><b>Subtotal</b></td>
                                    <td class="text-right">{{ getSubtotal | currency }}</td>
                                    <td></td>
                                  </tr>
                                  <tr>
                                    <td colspan="10" class="text-right"><b>Discount</b></td>
                                    <td class="text-right">({{ sales.discount | currency }})</td>
                                    <td></td>
                                  </tr>
                                  <tr>
                                    <td colspan="10" class="text-right"><b>DPP</b></td>
                                    <td class="text-right">{{ getTotalDPP | currency }}</td>
                                    <td></td>
                                  </tr>
                                  <tr>
                                    <td colspan="10" class="text-right"><b>Tax</b></td>
                                    <td class="text-right">{{ sales.tax | currency }}</td>
                                    <td></td>
                                  </tr>
                                  <tr v-if="sales.return_total > 0">
                                    <td colspan="10" class="text-right"><b><i>Retur</i></b></td>
                                    <td class="text-right">{{ sales.return_total | currency }}</td>
                                    <td></td>
                                  </tr>
                                  <tr>
                                    <td colspan="10" class="text-right"><b>Total</b></td>
                                    <td class="text-right">{{ sales.total | currency }} ({{ totalAfterReturn | currency }})</td>
                                    <td></td>
                                  </tr>
                                  <tr>
                                    <td colspan="12">&nbsp;</td>
                                  </tr>
                                  <tr>
                                    <td colspan="10" class="text-right"><b>Payment</b></td>
                                    <td class="text-right">{{ totalPayment | currency }}</td>
                                    <td></td>
                                  </tr>
                                  <tr>
                                    <td colspan="10" class="text-right"><b class="text-style"><i>Outstanding</i></b></td>
                                    <td class="text-right">{{ totalOutstanding | currency }}</td>
                                    <td></td>
                                  </tr>
                                </tfoot>
                              </table>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="tab-pane" id="summary">
                        <div class="table-responsive">
                          <table class="table table-sm table-item table-hover">
                            <thead>
                              <th>Product</th>
                              <th>Qty</th>
                              <th style="width: 10%">Uom</th>
                              <th class="text-right">Price</th>
                              <th class="text-right">Discount</th>
                              <th class="text-right">%</th>
                              <th class="text-right">Subtotal(DPP)</th>
                              <th class="text-right">Tax /item</th>
                              <th class="text-right">Total</th>
                              <th style="width: 10%">#</th>
                            </thead>
                            <tbody>
                              <tr v-for="(g, index) in groupDetail" :key="index">
                                <td><b>[{{ g.product_no }}]</b> {{ g.description }}</td>
                                <td>{{ g.qty }}</td>
                                <td>{{ g.uom_id }}</td>
                                <td class="text-right">{{ g.price | currency }}</td>
                                <td class="text-right">{{ g.discount | currency }}</td>
                                <td class="text-right">{{ g.discount_percentage }}</td>
                                <td class="text-right">{{ g.subtotal | currency }}</td>
                                <td class="text-right">{{ g.tax | currency }}</td>
                                <td class="text-right">{{ g.total | currency }}</td>
                                <td></td>
                              </tr>
                            </tbody>
                            <tfoot>
                              <tr>
                                <td colspan="8" class="text-right"><b>Subtotal</b></td>
                                <td class="text-right">{{ getSubtotal | currency }}</td>
                                <td></td>
                              </tr>
                              <tr>
                                <td colspan="8" class="text-right"><b>Discount</b></td>
                                <td class="text-right">({{ sales.discount | currency }})</td>
                                <td></td>
                              </tr>
                              <tr>
                                <td colspan="8" class="text-right"><b>DPP</b></td>
                                <td class="text-right">{{ getTotalDPP | currency }}</td>
                                <td></td>
                              </tr>
                              <tr>
                                <td colspan="8" class="text-right"><b>Tax</b></td>
                                <td class="text-right">{{ sales.tax | currency }}</td>
                                <td></td>
                              </tr>
                              <tr v-if="sales.return_total > 0">
                                <td colspan="8" class="text-right"><b><i>Retur</i></b></td>
                                <td class="text-right">{{ sales.return_total | currency }}</td>
                                <td></td>
                              </tr>
                              <tr>
                                <td colspan="8" class="text-right"><b>Total</b></td>
                                <td class="text-right">{{ sales.total | currency }}</td>
                                <td>
                                </td>
                              </tr>
                            </tfoot>
                          </table>
                        </div>
                      </div>
                      <div class="tab-pane" id="payment">
                        <div class="table-responsive">
                          <table class="table table-sm table-item table-striped">
                            <thead>
                              <th>Group</th>
                              <th>Payment No.</th>
                              <th>Date</th>
                              <th>Method</th>
                              <th>Account</th>
                              <th>Note</th>
                              <th>Amount</th>
                            </thead>
                            <tbody>
                              <tr v-for="p in sales.payments" :key="p.id">
                                <td>{{ p.group_no }}</td>
                                <td>{{ p.payment_no }}</td>
                                <td>{{ p.payment_date | dateFormat('DD/MM/YYYY') }}</td>
                                <td>{{ p.method }}</td>
                                <td>{{ p.account }}</td>
                                <td>{{ p.notes }}</td>
                                <td>{{ p.price | currency }}</td>
                              </tr>
                              <tr>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td>{{ totalPayment | currency }}</td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                      </div>
                      <div class="tab-pane" id="journal">
                        <div class="table-responsive">
                          <table class="table table-sm table-item table-hover table-striped">
                            <thead>
                              <th>Journal Code</th>
                              <th>Date</th>
                              <th>Account Code</th>
                              <th>Remark</th>
                              <th class="text-right">Debit</th>
                              <th class="text-right">Credit</th>
                            </thead>
                            <tbody>
                              <tr v-for="j in sales.journals" :key="j.id">
                                <td>
                                  <span v-if="j.level === 1">
                                    <b>{{ j.journal_code }} - {{ j.journal_description }}</b>&nbsp;
                                    <span class="badge badge-success" v-if="j.status === 'posted'">{{ j.status }}</span>
                                    <span class="badge badge-warning" v-else-if="j.status === 'draft'">{{ j.status }}</span>
                                  </span>
                                  <span v-else></span>
                                </td>
                                <td>{{ j.journal_date | dateFormat('DD/MM/YYYY') }}</td>
                                <td><b>{{ j.account_code }} {{ j.account }}</b></td>
                                <td>{{ j.remark }}</td>
                                <td class="text-right">
                                  <span v-if="j.level === 2">{{ j.debit | currency }}</span>
                                  <span v-if="j.level === 3"><b>{{ j.debit | currency }}</b></span>
                                  <span v-else></span>
                                </td>
                                <td class="text-right">
                                  <span v-if="j.level === 2">{{ j.credit | currency }}</span>
                                  <span v-if="j.level === 3"><b>{{ j.credit | currency }}</b></span>
                                  <span v-else></span>
                                </td>
                              </tr>
                            </tbody>
                          </table>
                          <button type="button" class="btn btn-sm btn-success pull-right" @click="postJournal">Post</button>
                        </div>
                      </div>
                      <div class="tab-pane" id="deliver">
                        <div class="table-responsive">
                          <h5><b>{{ deliveryData.deliver_no }} - {{ deliveryData.deliver_date | dateFormat('DD/MM/YYYY') }}</b></h5>
                          <table class="table table-sm table-item table-hover table-striped">
                            <thead>
                              <th>No</th>
                              <th>Warehouse</th>
                              <th>Product</th>
                              <th>Qty</th>
                              <th>Uom</th>
                              <th></th>
                            </thead>
                            <tbody>
                              <tr v-for="(u, index) in deliverDetailData" :key="u.id">
                                <td>{{ u.queue }}</td>
                                <td>{{ u.warehouse_no }}</td>
                                <td><b>[{{ u.product_no }}]</b> {{ u.product }}</td>
                                <td>{{ u.qty }}</td>
                                <td>{{ u.uom_id }}</td>
                                <td>
                                  <button type="button" class="btn btn-sm btn-info" @click="moveDeliverUp(index)">
                                    <i class="fa fa-arrow-circle-up" aria-hidden="true"></i>
                                  </button>
                                  <button type="button" class="btn btn-sm btn-info" @click="moveDeliverDown(index)">
                                    <i class="fa fa-arrow-circle-down" aria-hidden="true"></i>
                                  </button>
                                </td>
                              </tr>
                            </tbody>
                          </table>
                          <!-- <pre>{{ deliveryData }}</pre> -->
                        </div>
                      </div>
                    </div>
                </div>
              </div>
              <!-- <div class="row" v-show="sales.sale_no !== null">
                  <div class="col-md-12">
                    <h5>Retur</h5>
                    <table class="table table-sm table-item table-stiped">
                      <thead>
                        <th>Date</th>
                        <th>Product</th>
                        <th>Warehouse</th>
                        <th>Qty</th>
                        <th>UoM</th>
                        <th>Serial Number</th>
                        <th>Reason</th>
                        <th>Total</th>
                        <th></th>
                        </thead>
                        <tbody>
                            <tr v-for="d in getRetur" :key="d.id" >
                              <td>{{ d.return_date | dateFormat('DD/MM/YYYY') }}</td>
                              <td>[{{ d.product_no }}] {{ d.description }}</td>
                              <td>
                                <select v-model="d.warehouse_no" id="warehouse" class="form-control">
                                  <option v-for="w in warehouseList" :key="w.id" :value="w.warehouse_no">{{ w.name }}</option>
                                </select>
                              </td>
                              <td><input type="text" v-model="d.qty" class="form-control" v-on:keyup="calcRow(d.id)"/></td>
                              <td>
                                <select v-model="d.uom_id" class="form-control" @change="calcRow(d.id)">
                                  <option v-for="u in d.uomList" :value="u.id" :key="u.id">{{ u.name }}</option>
                                </select>
                              </td>
                              <td>
                                <input type="text" v-model="d.serial_number" class="form-control" v-if="d.products.canBarcode"/>
                                <input type="text" v-model="d.serial_number" class="form-control" v-else disabled="disabled"/>
                              </td>
                              <td><input type="text" v-model="d.reason" class="form-control"/></td>
                              <td>{{ d.total | currency }}</td>
                              <td>
                                <button type="button" class="btn btn-sm btn-danger" @click="deleteRetur(d.id)">
                                  <i class="fa fa-trash"></i>
                                </button>
                              </td>
                            </tr>
                        </tbody>
                    </table>
                  </div>
                </div> -->
            </div>
            <div class="card-footer">
            </div>
          </div>
        </div>
        <div :class="card2" v-if="card2 !== null">
          <div class="card card-list">
            <div class="card-header">
              <h5 class="text-primary">
                <span>Order List</span>
              </h5>
            </div>
            <div class="card-body">
              <input type="search" class="form-control" v-model="searchQueryOrder" placeholder="search..."/>
              <div class="table-responsive">
                <table class="table table-sm table-item table-hover table-striped">
                  <thead>
                    <th>SP No</th>
                    <th>Product No.</th>
                    <th>Product name</th>
                    <th>Qty Order</th>
                    <th>Qty Sales</th>
                    <th>Uom</th>
                  </thead>
                  <tbody>
                    <tr v-for="c in customerOrderList" :key="c.id">
                      <td>{{ c.project_name }}</td>
                      <td>{{ c.product_no }}</td>
                      <td>{{ c.product }}</td>
                      <td>{{ c.qty }}</td>
                      <td>{{ c.qty_done }}</td>
                      <td>{{ c.uom_id }}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- <SalesDetailModal :idDetail="idDetail" :sales="sales" @selectProduct="selectProduct" :amountDue="getTotal"/> -->
      <CustomerFormModal @createCustomer="createCustomer" />
      <CustomerListModal @selectCustomerList="selectCustomerList" />
      <SalesProductModal @selectProduct="selectProduct" :sales="sales" :status="status" :date="sales.sale_date"/>
      <SaleProjectModal :sales="sales"/>
      <SaleOrderModal @selectTemplate="selectTemplate" @selectOrderMulti="setCustomerOrder"/>
      <SalesRequestModal @getRequestEdit="requestEdit" @getRequestVoid="requestVoid"/>
      <UnitModal @selectUnitList="selectUnitList"/>
      <!-- <SaleReturModal :detail="detail" @returDetail="returDetail"/> -->
      <!-- <pre>{{ userAll }}</pre> -->
      <div class="row justify-content-md-center">
        <div class="col-md-6">
          <h5>Logs:</h5>
          <div class="alert alert-info" role="alert" v-for="l in sales.logs" :key="l.id">
            <b>{{ l.user }}</b> - {{ l.log_date | dateFormat('DD/MM/YYYY HH:mm:ss') }} <span>"{{ l.description }}"</span>
          </div>
        </div>
      </div>
      <div class="row">
        <!-- <div class="col-md-6"><pre>{{ sales }}</pre></div> -->
        <!-- <div class="col-md-6"><pre>{{ getEmployee }}</pre></div> -->
      </div>
    </div>
</template>

<script>
import axios from 'axios'
import { mapState } from 'vuex'
import Loading from 'vue-loading-overlay'
import CustomerFormModal from '@/components/customer/CustomerFormModal.vue'
import CustomerListModal from '@/components/customer/CustomerListModal.vue'
import SalesProductModal from '@/components/sales/SalesProductModal.vue'
import SaleProjectModal from '@/components/sales/SaleProjectModal.vue'
import SaleOrderModal from '@/components/sales/SaleOrderModal.vue'
import SalesRequestModal from '@/components/sales/SalesRequestModal.vue'
import UnitModal from '@/components/unit/UnitModal.vue'
import { productUrl, salesUrl, salesDetailUrl, setQtyTotalUrl, getHeader, salesReturUrl, lockUrl, customerUrl, sale2Url, journalUrl, saleOrderUrl } from '../../config'

export default {
  name: 'SalesUnitForm',
  props: ['sales', 'detailColl'],
  components: {
    CustomerFormModal,
    CustomerListModal,
    SalesProductModal,
    SaleProjectModal,
    SaleOrderModal,
    SalesRequestModal,
    Loading,
    UnitModal
  },
  created () {
    // Add barcode scan listener and pass the callback function
    console.log('has listener ' + this.$barcodeScanner.hasListener())
  },
  mounted () {
    this.$barcodeScanner.init(this.onBarcodeScanned)
  },
  destroyed () {
    // +Remove listener when component is destroyed
    console.log('Remove listener when component is destroyed')
    this.$barcodeScanner.destroy()
  },
  data () {
    return {
      alert: [],
      card1: 'col-md-12',
      card2: null,
      searchQueryOrder: '',
      status: 'sales',
      loader: {
        isLoading: false,
        fullPage: true,
        color: '#007bff',
        canCancel: true,
        height: 128,
        width: 128,
        backgroundColor: '#ffffff',
        loader: 'spinner'
      },
      dataPostJournal: {},
      dataSales: {},
      productStatus: null,
      idNew: null,
      idDetail: null,
      detail: null,
      money: {
        decimal: ',',
        thousands: '.',
        prefix: '',
        suffix: '',
        precision: 0,
        masked: true /* doesn't work with directive */
      }
    }
  },
  computed: {
    ...mapState({
      warehouseList: state => state.warehouses.warehouseList,
      salesTypeList: state => state.sales.salesTypeList,
      branchList: state => state.branches.branchList,
      productList: state => state.products.productList,
      taxList: state => state.taxes.taxList,
      methodList: state => state.payments.methodList,
      uomList: state => state.uom.uomList,
      priceListGroup: state => state.priceLists.priceListGroup,
      userAll: state => state.users.userAll,
      bankList: state => state.banks.bankList,
      vendorList: state => state.vendors.vendorList,
      authUser: state => state.users.authUser,
      termDueList: state => state.termduedates.termDueList,
      companyList: state => state.companies.companyList,
      employeeList: state => state.employees.employeeList
    }),
    totalAfterReturn () {
      var sum = 0
      sum = this.sales.total - this.totalReturn
      return sum
    },
    totalOutstanding () {
      var sum = 0
      sum = this.sales.total - this.totalReturn - this.totalPayment
      return sum
    },
    groupDetailColl () {
      var result = []
      if (this.detailColl.length > 0) {
        this.detailColl.reduce(function (res, value) {
          var key = value.product_no
          var qty = parseFloat(value.qty)
          if (!res[key]) {
            res[key] = {
              product_no: key,
              qty: qty
            }
            result.push(res[key])
          } else {
            res[key].qty = parseFloat(res[key].qty) + qty
          }
          return res
        }, {})
      }
      return result
    },
    groupDetail () {
      var result = []
      if (this.sales.details.length > 0) {
        this.sales.details.reduce(function (res, value) {
          // key = Date.parse(value.cost_date) + value.queue + value.company_no
          var key = value.product_no + value.price
          var price = parseFloat(value.price.replace(/\./g, ''))
          var qty = parseFloat(value.qty)
          var total = (parseFloat(value.subtotal) + parseFloat(value.tax)) * qty
          if (!res[key]) {
            res[key] = {
              sale_no: value.sale_no,
              sale_date: value.sale_date,
              branch_no: value.branch_no,
              product_no: value.product_no,
              product: value.product,
              product_sku: value.product_sku,
              description: value.description,
              barcode: value.barcode,
              qty: qty,
              serial_number: value.serial_number,
              sec_serial_number: value.sec_serial_number,
              uom_id: value.uom_id,
              price: price,
              tax_id: value.tax_id,
              tax: value.tax,
              discount: value.discount,
              discount_percentage: value.discount_percentage,
              subtotal: value.subtotal,
              total: total,
              queue: value.queue,
              warehouse_no: value.warehouse_no,
              edit: value.edit,
              company_no: value.company_no,
              order_no: value.order_no,
              uomList: value.uomList,
              cost: value.cost,
              cost_id: value.cost_id,
              margin: value.margin,
              margin_percentage: value.margin_percentage,
              internal_code: value.internal_code
            }
            result.push(res[key])
          } else {
            res[key].qty = res[key].qty + qty
            res[key].total = res[key].total + total
          }
          return res
        }, {})
      }
      // return result
      var col = 'date'
      var ascending = true
      // eslint-disable-next-line vue/no-side-effects-in-computed-properties
      return result.sort(function (a, b) {
        if (a[col] > b[col]) {
          return ascending ? 1 : -1
        } else if (a[col] < b[col]) {
          return ascending ? -1 : 1
        }
        return 0
      })
    },
    totalReturn () {
      var sum = 0
      var array = this.dataReturn
      for (let a = 0; a < array.length; a++) {
        sum += parseFloat(array[a].total)
      }
      return sum
    },
    totalPayment () {
      var array = this.sales.payments
      var sum = 0
      for (let a = 0; a < array.length; a++) {
        sum += parseFloat(array[a].price)
      }
      return sum
    },
    getDataDetails () {
      var col = 'queue'
      var ascending = true
      // eslint-disable-next-line vue/no-side-effects-in-computed-properties
      return this.sales.details.sort(function (a, b) {
        if (a[col] > b[col]) {
          return ascending ? 1 : -1
        } else if (a[col] < b[col]) {
          return ascending ? -1 : 1
        }
        return 0
      })
    },
    getEmployeeDriver () {
      var array = this.employeeList.filter(d => d.position === 'Driver')
      var loop = []
      for (let a = 0; a < array.length; a++) {
        var obj = {
          salesman: '[' + array[a].employee_no + '] ' + array[a].name,
          meta: {
            code: array[a].employee_no
          }
        }
        loop.push(obj)
      }
      return loop
    },
    deliverDetailData () {
      var data = []
      if (this.deliveryData.details.length > 0) {
        var col = 'queue'
        var ascending = true
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
        data = this.deliveryData.details.sort(function (a, b) {
          if (a[col] > b[col]) {
            return ascending ? 1 : -1
          } else if (a[col] < b[col]) {
            return ascending ? -1 : 1
          }
          return 0
        })
      }
      return data
    },
    deliveryData () {
      var delivery = this.sales.deliveries[0]
      var obj = {
        id: null,
        deliver_no: delivery.deliver_no,
        sale_no: this.sales.sale_no,
        deliver_date: this.sales.sale_date,
        notes: delivery.notes,
        employee_no: delivery.employee_no,
        type_id: delivery.type_id,
        branch_no: delivery.branch_no,
        company_no: delivery.company_no,
        delivery_term: delivery.delivery_term,
        details: delivery.details
      }
      return obj
    },
    totalDetail () {
      var sum = 0
      var array = this.sales.details
      for (let i = 0; i < array.length; i++) {
        sum += parseFloat(array[i].total)
      }
      return sum
    },
    totalDetailTax () {
      var sum = 0
      var array = this.sales.details
      for (let i = 0; i < array.length; i++) {
        sum += parseFloat(array[i].qty) * parseFloat(array[i].tax)
      }
      return sum
    },
    totalDetailDiscount () {
      var sum = 0
      var array = this.sales.details
      for (let i = 0; i < array.length; i++) {
        sum += parseFloat(array[i].qty) * parseFloat(array[i].discount)
      }
      return sum
    },
    dataReturn () {
      var array = this.sales.returns[0].details
      return array
    },
    customerOrderList () {
      var array = this.sales.orders
      var loop = []
      for (let i = 0; i < array.length; i++) {
        var arrDetail = array[i].details
        for (let a = 0; a < arrDetail.length; a++) {
          var obj = {
            id: arrDetail[a].id,
            order_no: array[i].order_no,
            order_date: array[i].order_date,
            project_name: array[i].project_name,
            product_no: arrDetail[a].product_no,
            product: arrDetail[a].description,
            qty: arrDetail[a].qty,
            qty_done: arrDetail[a].qty_done,
            uom_id: arrDetail[a].uom_id
          }
          loop.push(obj)
        }
      }
      return loop.filter(d => {
        for (const name in d) {
          if (d[name] !== null) {
            if (d[name].toString().toLowerCase().indexOf(this.searchQueryOrder.toLowerCase()) > -1) {
              return d
            }
          }
        }
      })
    },
    getTotalPrice () {
      var array = this.sales.details
      var sum = 0
      for (let i = 0; i < array.length; i++) {
        sum += parseFloat(array[i].price.replace(/\./g, ''))
      }
      return sum
    },
    getTotalDiscount () {
      var array = this.sales.details
      var sum = 0
      for (let i = 0; i < array.length; i++) {
        sum += parseFloat(array[i].qty) * parseFloat(array[i].discount.replace(/\./g, ''))
      }
      return sum
    },
    getTotalDPP () {
      var array = this.sales.details
      var sum = 0
      for (let i = 0; i < array.length; i++) {
        var dpp = array[i].subtotal
        sum += parseFloat(array[i].qty) * parseFloat(dpp)
      }
      return sum
    },
    getTotalTax () {
      var array = this.sales.details
      var sum = 0
      var tax = this.taxList.find(d => d.id === this.sales.tax_id)
      console.log('Tax:')
      console.log(tax)
      if (tax) {
        for (let i = 0; i < array.length; i++) {
          var taxAmount = 0
          if (tax.include === false) {
          } else {
            if (tax.amount === '11') {
              // Old
              taxAmount = parseFloat(array[i].subtotal) * 11 / 100
              console.log('getTotalTax:' + taxAmount)
              sum += parseFloat(array[i].qty) * taxAmount
            } else {
              taxAmount = parseFloat(array[i].subtotal) * 10 / 100
              sum += parseFloat(array[i].qty) * taxAmount
            }
          }
        }
      }
      return Math.round(sum)
    },
    getTotalTaxDetail () {
      var array = this.sales.details
      var sum = 0
      for (let i = 0; i < array.length; i++) {
        sum += parseFloat(array[i].qty) * parseFloat(array[i].tax)
      }
      return sum
    },
    getTotalDetail () {
      var sum = 0
      sum = this.getTotalDPP + this.getTotalTax
      return sum
    },
    getAmountDue: function () {
      var total = this.sales.total - this.getTotalPaid
      return total
    },
    paymentList: function () {
      return this.sales.payments.filter(d => d.id !== null)
    },
    getNetProfit: function () {
      var total = this.getGrossProfit - this.getOpex
      return total
    },
    getNetProfitPercentage: function () {
      var total = 0
      total = (this.getNetProfit / parseFloat(this.getTotal)) * 100
      return Math.ceil(total)
    },
    getOpex: function () {
      var sum = 0
      var array = this.sales.opexs
      for (let i = 0; i < array.length; i++) {
        sum += parseFloat(array[i].amount.replace(/\./g, ''))
      }
      return sum.toString()
    },
    getGrossProfit: function () {
      var total = 0
      total = parseFloat(this.getTotal) - parseFloat(this.getTotalCost)
      return total
    },
    getGrossProfitPercentage: function () {
      var total = 0
      total = (this.getGrossProfit / parseFloat(this.getTotal)) * 100
      return Math.ceil(total)
    },
    getTotalCost: function () {
      var array = this.sales.details
      var sum = 0
      for (let i = 0; i < array.length; i++) {
        sum += parseFloat(array[i].cost.replace(/\./g, '')) * parseFloat(array[i].qty)
      }
      return sum.toString()
    },
    getTotalMargin: function () {
      var array = this.sales.details
      var sum = 0
      for (let i = 0; i < array.length; i++) {
        sum += parseFloat(array[i].margin) * parseFloat(array[i].qty)
      }
      return sum.toString()
    },
    getUserSalesman: function () {
      var array = this.employeeList.filter(e => e.position_id === 'H4.1' || e.position_id === 'H4.2' || e.position_id === 'H1' || e.position_id === 'H2')
      var loop = []
      for (let a = 0; a < array.length; a++) {
        var obj = {
          salesman: '[' + array[a].employee_no + '] ' + array[a].name,
          meta: {
            code: array[a].employee_no
          }
        }
        loop.push(obj)
      }
      return loop
    },
    getUserDeliveryman: function () {
      var array = this.employeeList
      var loop = []
      for (let a = 0; a < array.length; a++) {
        var obj = {
          deliver: '[' + array[a].employee_no + '] ' + array[a].name,
          meta: {
            code: array[a].employee_no
          }
        }
        loop.push(obj)
      }
      return loop
    },
    getVendor: function () {
      var array = this.vendorList
      var loop = [{
        vendor: '---',
        meta: {
          code: null
        }
      }]
      for (let i = 0; i < array.length; i++) {
        var obj = {
          vendor: array[i].name,
          meta: {
            code: array[i].vendor_no
          }
        }
        loop.push(obj)
      }
      return loop
    },
    getTotalRetur: function () {
      var array = this.sales.returs
      var sum = 0
      for (let i = 0; i < array.length; i++) {
        sum += array[i].total
      }
      return sum
    },
    getRetur: function () {
      return this.sales.returs.filter(d => d.id !== null)
    },
    getWarehouseBranch: function () {
      if (this.sales.branch_no !== null) {
        return this.warehouseList.filter(d => d.branch_no === this.sales.branch_no)
      } else {
        return this.warehouseList
      }
    },
    salesDetail: function () {
      return this.sales.details.filter(d => d.id !== null)
    },
    getSubtotal: function () {
      var array = this.sales.details
      var sum = 0
      for (let i = 0; i < array.length; i++) {
        if (array[i].price !== '0') {
          sum += parseFloat(array[i].price.replace(/\./g, '')) * parseFloat(array[i].qty)
        }
      }
      return sum
    },
    getSubtotal2: function () {
      var array = this.sales.details
      var sum = 0
      for (let i = 0; i < array.length; i++) {
        var amount = parseFloat(array[i].total)
        sum += amount
      }
      return sum
    },
    getTax: function () {
      var subtotal = this.getSubtotal
      var discount = parseFloat(this.sales.discount.replace(/\./g, ''))
      var taxId = this.sales.tax_id
      var taxAmount = 0
      var taxLis = this.taxList.find(d => d.id === taxId)
      if (taxLis) {
        if (taxLis.include === false) {
          taxAmount = (subtotal - discount) * (parseInt(taxLis.amount) / 100)
          return taxAmount.toString()
        } else {
          return '0'
        }
      } else {
        return '0'
      }
    },
    getTotalPaid: function () {
      var sum = 0
      var array = this.sales.payments
      for (let i = 0; i < array.length; i++) {
        sum += parseFloat(array[i].price.replace(/\./g, ''))
      }
      return sum
    },
    getRemaining: function () {
      var total = this.sales.total
      var paid = this.getTotalPaid
      var remaining = total - paid
      return remaining
    }
  },
  methods: {
    removeUnit (index) {
      var detail = this.sales.units[index]
      if (detail.sale_no === null) {
        this.sales.units.splice(index, 1)
      } else {
        this.$swal.fire({
          title: 'Are you sure Delete this?',
          text: "You won't be able to revert this!",
          icon: 'error',
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: 'Yes, delete it!'
        }).then((result) => {
          if (result.value) {
            axios.delete(salesUrl + '/unit/' + detail.id, { headers: getHeader() })
              .then(response => {
                console.log(response.data.message)
                this.sales.units.splice(index, 1)
              })
              .catch(error => {
                console.log(error.response)
              })
          }
        })
      }
    },
    selectUnitList (value) {
      var array = value
      for (let i = 0; i < array.length; i++) {
        var check = this.sales.units.find(d => d.id === array[i].id)
        if (!check) {
          var obj = {
            id: array[i].id,
            unit_no: array[i].unit_no,
            unit_date: array[i].unit_date,
            type_id: array[i].type_id,
            name: array[i].name,
            alias: array[i].alias,
            schedule_date: array[i].schedule_date,
            storage_date: array[i].storage_date,
            start_date: array[i].start_date,
            finish_date: array[i].finish_date,
            sale_no: this.sales.sale_no,
            notes: array[i].notes,
            company_no: array[i].company_no,
            asset_no: array[i].asset_no,
            customer_no: array[i].customer_no,
            check_person: array[i].check_person,
            created_by: array[i].created_by,
            status: array[i].status,
            lock: array[i].lock,
            product_no: array[i].product_no,
            fuel_bar: array[i].fuel_bar,
            fuel_total: array[i].fuel_total,
            fuel_uom: array[i].fuel_uom
          }
          this.sales.units.push(obj)
        }
      }
    },
    async getUnitList () {
      var date = new Date(this.sales.sale_date)
      var newDate = date.getFullYear() + '-' + (parseInt(date.getMonth()) + 1) + '-' + date.getDate()
      var payload = {
        begin: newDate,
        end: newDate
      }
      console.log(payload)
      this.$store.dispatch('getUnitList', payload)
    },
    async requestVoid (value) {
      var obj = {
        request_by: this.authUser.username,
        lock_no: this.sales.sale_no,
        lock_note: value,
        type: 'sales-void'
      }
      console.log(obj)
      await axios.post(lockUrl, obj, { headers: getHeader() })
        .then(response => {
          this.$swal('Lock', 'Order has been requested (' + this.sales.sale_no + ')', 'success')
          this.$emit('backClicked')
        })
        .catch(error => {
          console.log(error)
          console.log(error.response)
          this.$swal('Error', error.response.data.message, 'error')
          throw error
        })
    },
    async unlock () {
      var body = {
        id: this.sales.id
      }
      await this.$swal.fire({
        title: 'Are you sure unlock this?',
        text: "You won't be able to revert this!",
        icon: 'error',
        showCancelButton: true,
        confirmButtonColor: '#28A745',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Yes, Unlock it!'
      }).then((result) => {
        if (result.value) {
          console.log(salesUrl + '/unlock')
          axios.post(salesUrl + '/unlock', body, { headers: getHeader() })
            .then(response => {
              console.log(response.data.message)
              this.$swal('Success', response.data.message, 'success')
              this.$emit('backClicked')
            })
            .catch(error => {
              console.log(error)
              console.log(error.response)
              this.$swal('Error', error.response.data.message, 'error')
              throw error
            })
        }
      })
    },
    async checkDate () {
      var date1 = new Date()
      date1.setHours(0, 0, 0, 0)
      var date2 = new Date(this.sales.sale_date)
      date2.setHours(0, 0, 0, 0)
      var remaining = date2.getTime() - date1.getTime()
      var diffInDay = remaining / (1000 * 3600 * 24)
      console.log('Diff in a day ' + diffInDay)
      if (diffInDay > 1) {
        this.$swal('Error', 'Tanggal tidak boleh lebih dari hari ini (' + diffInDay + ' hari)', 'error')
        this.sales.sale_date = date1
      } else if (Math.abs(diffInDay) > 2) {
        this.$swal('Error', 'Tanggal tidak boleh kurang dari 2 hari', 'error')
        this.sales.sale_date = date1
      }
    },
    async removeSales () {
      var resp = {
        error: false,
        message: null
      }
      await this.$swal.fire({
        title: 'Are you sure Delete this?',
        text: "You won't be able to revert this!",
        icon: 'error',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Yes, delete it!'
      }).then((result) => {
        if (result.value) {
          this.$Progress.start()
          this.loader.isLoading = true
          axios.delete(salesUrl + '/' + this.sales.id, { headers: getHeader() })
            .then(response => {
              console.log(response.data.message)
              resp.error = true
              resp.message = response.data.message
            })
            .catch(error => {
              this.$Progress.fail()
              this.loader.isLoading = false
              console.log(error)
              console.log(error.response)
              this.$swal('Error', error.response.data.message, 'error')
              throw error
            })
        }
      })
      await this.$Progress.finish()
      this.loader.isLoading = false
      if (resp.error === false) {
        await this.syncOrderAll('no reply')
        await this.$swal('Success', resp.message, 'success')
        await this.backParent()
        this.alert = []
      }
    },
    setTypeSales () {
      if (this.sales.type_id === 1) {
        var salesType = this.salesTypeList.find(d => d.id === this.sales.type_id)
        console.log(salesType)
        this.sales.term_due_id = salesType ? salesType.term_due_date_id : null
      }
    },
    async refreshCalc () {
      var array = this.sales.details
      for (let i = 0; i < array.length; i++) {
        await this.calcRow([i])
      }
      console.log('success refresh calcrow')
    },
    async setJournalReturn () {
      const id = this.sales.returs[0].id
      if (id) {
        var resp = {
          error: false,
          message: ''
        }
        await axios.get(salesUrl + '/journal-return/' + id, { headers: getHeader() })
          .then(response => {
            console.log(response.data.message)
            resp.error = false
            resp.message = response.data.message
          })
          .catch(error => {
            console.log(error.response)
            resp.error = true
            resp.message = error.response.data.message
            throw error
          })
        await axios.get(salesUrl + '/journal-return-stock/' + id, { headers: getHeader() })
          .then(response => {
            console.log(response.data.message)
            resp.error = false
            resp.message = response.data.message
          })
          .catch(error => {
            console.log(error.response)
            resp.error = true
            resp.message = error.response.data.message
            throw error
          })
        if (resp.error) {
          this.$swal('Error', resp.message, 'error')
        } else {
          await this.$swal('Success', resp.message, 'success')
          this.$emit('backClickID', this.sales.id)
        }
      }
    },
    async setJournalAll () {
      await this.setJournalSingle()
      await this.setJournalStockSingle()
    },
    moveDeliverUp (index) {
      var current = index
      var before = index - 1
      var currentData = {}
      var beforeData = {}
      if (current < 0) {
      } else {
        currentData = this.deliveryData.details[current]
        beforeData = this.deliveryData.details[before]
        if (currentData.queue === 1) {
        } else {
          console.log(currentData.queue)
          console.log(beforeData.queue)
          currentData.queue = currentData.queue - 1
          beforeData.queue = beforeData.queue + 1
        }
      }
    },
    moveDeliverDown (index) {
      var current = index
      var next = index + 1
      var currentData = {}
      var nextData = {}
      if (current < 0) {
      } else {
        currentData = this.deliveryData.details[current]
        nextData = this.deliveryData.details[next]
        if (currentData.queue === this.deliveryData.details.length) {
        } else {
          currentData.queue = currentData.queue + 1
          nextData.queue = nextData.queue - 1
        }
      }
    },
    moveUp (index) {
      var current = index
      var before = index - 1
      var currentData = {}
      var beforeData = {}
      console.log(current)
      if (current < 0) {
      } else {
        currentData = this.sales.details[current]
        beforeData = this.sales.details[before]
        if (currentData.queue === 1) {
        } else {
          currentData.queue = currentData.queue - 1
          beforeData.queue = beforeData.queue + 1
        }
      }
    },
    moveDown (index) {
      var current = index
      var next = index + 1
      var currentData = {}
      var nextData = {}
      if (current < 0) {
      } else {
        currentData = this.sales.details[current]
        nextData = this.sales.details[next]
        if (currentData.queue === this.sales.details.length) {
        } else {
          currentData.queue = currentData.queue + 1
          nextData.queue = nextData.queue - 1
        }
      }
    },
    removeOrderAll () {
      if (this.sales.id === null) {
        this.sales.orders = []
        this.sales.details = []
      }
    },
    getCustomerOrderList () {
      var payload = {
        customer_no: this.sales.customer_no,
        company_no: this.sales.company_no,
        salesman_id: this.sales.salesman_id
      }
      this.$store.dispatch('getCustomerOrderList', payload)
    },
    async removeOrder (index) {
      var order = this.sales.orders[index]
      var array = this.sales.details.filter(d => d.order_no === order.order_no)
      for (let i = 0; i < array.length; i++) {
        var pdID = this.sales.details.findIndex(d => d.order_no === array[i].order_no)
        this.sales.details.splice(pdID, 1)
      }
      await this.sales.orders.splice(index, 1)
    },
    selectProductToOrder (product) {
      if (this.searchQueryOrder === null || this.searchQueryOrder === '') {
        this.searchQueryOrder = product
        this.card1 = 'col-md-8'
        this.card2 = 'col-md-4'
      } else if (this.searchQueryOrder === product) {
        if (this.searchQueryOrder !== product) {
          this.searchQueryOrder = ''
        } else {
          this.searchQueryOrder = ''
        }
        this.card1 = 'col-md-12'
        this.card2 = null
      }
    },
    async getOrderNo (order) {
      var payload = {
        order_no: order
      }
      console.log(payload)
      this.$store.dispatch('getOrderByNo', payload)
    },
    async getCustomerOrder () {
      if (this.sales.company_no === null || this.sales.company_no === '') {
        this.$swal(
          'Error',
          'Data company harus diisi',
          'error'
        )
        return false
      }
      if (this.sales.salesman_id === null || this.sales.salesman_id === '') {
        this.$swal(
          'Error',
          'Data salesman harus diisi',
          'error'
        )
        return false
      }
      this.$Progress.start()
      this.loader.isLoading = true
      this.sales.details = []
      var data = {
        customer_no: this.sales.customer_no,
        company_no: this.sales.company_no,
        salesman_id: this.sales.salesman_id
      }
      await axios.post(customerUrl + '/order', data, { headers: getHeader() })
        .then(response => {
          var array = response.data.data
          this.sales.orders = array
          for (let i = 0; i < array.length; i++) {
            var arr = array[i].details
            var no = 0
            for (let a = 0; a < arr.length; a++) {
              no += 1
              var sd = this.sales.details.find(d => d.product_no === arr[a].product_no)
              if (sd) {
                sd.qty += arr[a].qty
              } else {
                var obj = {
                  sales_no: this.sales.sales_no,
                  sale_date: this.sales.sale_date,
                  branch_no: this.sales.branch_no,
                  product_no: arr[a].product_no,
                  product_sku: arr[a].product_sku,
                  description: arr[a].description,
                  qty: arr[a].qty,
                  serial_number: null,
                  sec_serial_number: null,
                  uom_id: arr[a].uom_id,
                  price: arr[a].price,
                  tax_id: arr[a].tax_id,
                  tax: arr[a].tax,
                  discount: arr[a].discount === null ? '0' : arr[a].discount,
                  discount_percentage: arr[a].discount === null ? '0' : arr[a].discount_percentage,
                  subtotal: arr[a].subtotal,
                  total: arr[a].total,
                  queue: no,
                  warehouse_no: this.sales.warehouse_no,
                  cost: '0',
                  cost_id: null,
                  margin: '0',
                  margin_percentage: '0',
                  internal_code: null
                }
              }
              this.sales.details.push(obj)
            }
          }
          this.setTax()
          this.$Progress.finish()
          this.loader.isLoading = false
        })
        .catch(error => {
          console.log(error)
          this.$Progress.finish()
          this.loader.isLoading = false
        })
      await this.setTax()
    },
    async setCustomerOrder (value) {
      this.$Progress.start()
      this.loader.isLoading = true
      var array = value
      var coll = []
      for (let i = 0; i < array.length; i++) {
        this.sales.orders.push(value[i])
        var arr = array[i].details
        var no = 0
        for (let a = 0; a < arr.length; a++) {
          no += 1
          var qtyOutstading = parseFloat(arr[a].qty) - parseFloat(arr[a].qty_done)
          if (qtyOutstading > 0) {
            var uomList = []
            var qtyTotal = 0
            var body = {
              product_no: arr[a].product_no
            }
            await axios.post(productUrl + '/uom/list', body, { headers: getHeader() })
              .then(response => {
                uomList = response.data.data
                qtyTotal = response.data.qty_total
              })
              .catch(error => {
                console.log(error)
                console.log(error.response)
              })
            var obj = {
              sales_no: this.sales.sales_no,
              sale_date: this.sales.sale_date,
              branch_no: this.sales.branch_no,
              product_no: arr[a].product_no,
              product_sku: arr[a].product_sku,
              description: arr[a].description,
              qty: qtyOutstading,
              serial_number: null,
              sec_serial_number: null,
              uom_id: arr[a].uom_id,
              price: arr[a].price,
              tax_id: arr[a].tax_id,
              tax: arr[a].tax,
              discount: arr[a].discount === null ? '0' : arr[a].discount,
              discount_percentage: arr[a].discount === null ? '0' : arr[a].discount_percentage,
              subtotal: arr[a].subtotal,
              total: arr[a].total,
              queue: no,
              warehouse_no: this.sales.warehouse_no,
              cost: '0',
              cost_id: null,
              margin: '0',
              margin_percentage: '0',
              internal_code: null,
              order_no: arr[a].order_no,
              uomList: uomList,
              lock: false
            }
            console.log('qtyTotal:' + qtyTotal)
            this.sales.details.push(obj)
          }
        }
      }
      if (coll.length > 0) {
        var words = ''
        var header = ''
        for (let c = 0; c < coll.length; c++) {
          header = coll[c].message
          words = words + '- <b>[' + coll[c].pNo + ']</b> ' + coll[c].pName + '<br>'
        }
        console.log(words)
        this.$swal(header, words, 'error')
      }
      this.setTax()
      this.$Progress.finish()
      this.loader.isLoading = false
    },
    async requestEdit (value) {
      var obj = {
        request_by: this.authUser.username,
        lock_no: this.sales.sale_no,
        lock_note: value,
        type: 'sales'
      }
      console.log(obj)
      await axios.post(lockUrl, obj, { headers: getHeader() })
        .then(response => {
          this.$swal(
            'Lock',
            'Sales has been requested',
            'success'
          )
          this.$emit('backClicked')
        })
        .catch(error => {
          console.log(error)
        })
    },
    async approveAll () {
      await this.approveSales()
      await this.setCOGSAll('no reply')
      await this.setJournalAll()
    },
    async setCOGSAll (reply) {
      var array = this.sales.details
      for (let i = 0; i < array.length; i++) {
        var date = new Date(this.sales.sale_date)
        var newDate = date.getFullYear() + '-' + (parseInt(date.getMonth()) + 1) + '-' + date.getDate()
        var data = {
          date: newDate,
          product_no: array[i].product_no,
          type: 'all',
          company_no: this.sales.company_no
        }
        var resp = {
          error: false,
          message: null
        }
        await axios.post(productUrl + '/cost/sync', data, { headers: getHeader() })
          .then(response => {
            console.log('success sync cogs')
            console.log(response.data.data)
            resp.error = false
            resp.message = response.data.message
          })
          .catch(error => {
            console.log(error)
            console.log(error.response)
            this.$swal('Error', error.response.data.message, 'error')
            throw error
          })
      }
    },
    async setCOGS () {
      var array = this.sales.details
      for (let i = 0; i < array.length; i++) {
        var date = new Date(this.sales.sale_date)
        var newDate = date.getFullYear() + '-' + (parseInt(date.getMonth()) + 1) + '-' + date.getDate()
        var data = {
          date: newDate,
          product_no: array[i].product_no,
          type: 'sales',
          company_no: this.sales.company_no
        }
        await axios.post(productUrl + '/cost/sync', data, { headers: getHeader() })
          .then(response => {
            console.log('success sync cogs')
            console.log(response.data.data)
            this.$swal('Success', response.data.message, 'success')
          })
          .catch(error => {
            console.log(error)
          })
      }
    },
    async setJournalSingle () {
      await axios.get(salesUrl + '/journal/' + this.sales.id, { headers: getHeader() })
        .then(response => {
          this.$swal(
            'Success',
            response.data.message,
            'success'
          )
          this.$emit('backClickID', this.sales.id)
        })
        .catch(error => {
          console.log(error.response)
          this.$swal(
            'Error',
            error.response.data.message,
            'error'
          )
        })
    },
    async setJournal () {
      await axios.get(salesUrl + '/journal/' + this.sales.id, { headers: getHeader() })
        .then(response => {
          console.log(response.data.message)
        })
        .catch(error => {
          console.log(error.response)
        })
    },
    async setJournalPaymentSingle () {
      await axios.get(salesUrl + '/journal-payment/' + this.sales.id, { headers: getHeader() })
        .then(response => {
          this.$swal(
            'Success',
            response.data.message,
            'success'
          )
          this.$emit('backClickID', this.sales.id)
        })
        .catch(error => {
          console.log(error.response)
          this.$swal(
            'Error',
            error.response.data.message,
            'error'
          )
        })
    },
    async setJournalPayment () {
      await axios.get(salesUrl + '/journal-payment/' + this.sales.id, { headers: getHeader() })
        .then(response => {
          console.log(response.data.message)
        })
        .catch(error => {
          console.log(error.response)
        })
    },
    async setJournalStockSingle () {
      await axios.get(salesUrl + '/journal-stock-out/' + this.sales.id, { headers: getHeader() })
        .then(response => {
          this.$swal(
            'Success',
            response.data.message,
            'success'
          )
          this.$emit('backClickID', this.sales.id)
        })
        .catch(error => {
          console.log(error.response)
          this.$swal(
            'Error',
            error.response.data.message,
            'error'
          )
        })
    },
    async setJournalStock () {
      await axios.get(salesUrl + '/journal-stock-out/' + this.sales.id, { headers: getHeader() })
        .then(response => {
          console.log(response.data.message)
        })
        .catch(error => {
          console.log(error.response)
        })
    },
    async postJournal () {
      var array = this.sales.journals.filter(d => d.level === 1)
      for (let i = 0; i < array.length; i++) {
        var data = {
          id: array[i].id
        }
        await axios.post(journalUrl + '/posting', data, { headers: getHeader() })
          .then(response => {
          })
          .catch(error => {
            console.log(error.response)
            this.$swal('Error', error.response.data.message, 'error')
            return false
          })
      }
      await this.$swal('Success', 'Success Post All Journal', 'success')
      await this.$emit('backClickID', this.sales.id)
    },
    async approveSales () {
      await axios.put(salesUrl + '/approve/' + this.sales.id, this.sales, { headers: getHeader() })
        .then(response => {
          var array = this.sales.details
          console.log(array)
          for (let i = 0; i < array.length; i++) {
            var code = array[i].product_no
            this.setQtyTotal(code)
          }
          this.$swal('Success', response.data.message, 'success')
          this.$emit('backParentID', this.sales.id)
        })
        .catch(error => {
          console.log(error.response)
          this.$swal('Error', error.response.data.message, 'error')
        })
    },
    async setQtyTotal (code) {
      var d = new Date()
      var n = d.getFullYear()
      var n1 = n - 1
      this.year = [n1, n]
      var newYear = d.getFullYear()
      var newMonth = d.getMonth() + 1
      var newDate = d.getDate()
      var newSetDate = newYear + '-' + newMonth + '-' + newDate
      var comNo = this.sales.company_no

      await axios.get(setQtyTotalUrl + '?end=' + newSetDate + '&available=true&company_no=' + comNo + '&product_no=' + code, { headers: getHeader() })
        .then(response => {
          console.log(response.data.message)
        })
        .catch(error => {
          this.$swal(
            'Error',
            error.response.data.message,
            'error'
          )
        })
    },
    editPayment: function (id) {
      this.idNew = id
      var pay = this.sales.payments.find(d => d.id === id)
      pay.state = 'edit'
    },
    backToPayment: function (id) {
      var pay = this.sales.payments.find(d => d.id === id)
      if (pay.state === 'new') {
        var index = this.sales.payments.findIndex(d => d.id === id)
        this.sales.payments.splice(index, 1)
      }
    },
    addNewPayment: function () {
      this.idNew = Math.floor(Math.random() * (99999999 - 66666666) + 66666666)
      var obj = {
        id: this.idNew,
        payment_date: null,
        price: this.getAmountDue.toString(),
        method_id: null,
        method: null,
        type_id: null,
        type: null,
        bank_id: null,
        bank: null,
        account_no: null,
        notes: null,
        state: 'new'
      }
      this.sales.payments.push(obj)
    },
    selectTemplate: function (tmp) {
      console.log(tmp)
      this.sales.details = []
      var array = tmp.details
      var tax = this.taxList.find(d => d.id === this.sales.tax_id)
      var queue = 0
      for (let i = 0; i < array.length; i++) {
        queue += 1
        console.log(array[i].product_no)
        var value = this.productList.find(d => d.product_no === array[i].product_no)
        console.log(value)
        var dpp = value.price
        var totalTax = dpp * 10 / 100
        if (tax.include === false) {
          totalTax = dpp * tax.amount / 100
        } else {
          totalTax = 0
        }
        var obj = {
          sales_no: null,
          sale_date: null,
          branch_no: this.sales.branch_no,
          product_no: value.product_no,
          description: value.product_name,
          qty: array[i].qty,
          serial_number: null,
          uom_id: value.uom_id,
          price: value.price,
          tax_id: this.sales.tax_id,
          tax: totalTax,
          discount: '0',
          total: value.price,
          queue: queue,
          warehouse_no: null,
          state: 'create',
          edit: false,
          uomList: value.uomList,
          cost: value.product_cost.toString(),
          cost_id: value.cost_id,
          margin: '0',
          margin_percentage: '0',
          internal_code: null
        }
        this.sales.details.push(obj)
      }
    },
    getType: function () {
      // var styp = this.salesTypeList.find(d => d.id === this.sales.type_id)
      var date = new Date(this.sales.sale_date)
      var newDate = date.getFullYear() + '-' + (parseInt(date.getMonth()) + 1) + '-' + date.getDate()
      var obj = {
        priceID: this.sales.price_id,
        branch: this.sales.branch_no,
        warehouse: this.sales.warehouse_no,
        date: newDate
      }
      // this.sales.details = []
      console.log(obj)
      // this.$store.dispatch('getProductByPriceList', obj)
    },
    getProductList: function () {
      var date = new Date(this.sales.sale_date)
      var newDate = date.getFullYear() + '-' + (parseInt(date.getMonth()) + 1) + '-' + date.getDate()
      var obj = {
        priceID: this.sale.price_id,
        branch: this.sale.branch_no,
        warehouse: this.sale.warehouse_no,
        date: newDate
      }
      console.log(obj)
      // this.$store.dispatch('getProductByPriceList', obj)
    },
    removeOpex (index) {
      var detail = this.sales.opexs[index]
      if (detail.state === 'create') {
        this.sales.opexs.splice(index, 1)
      } else {
        this.$swal.fire({
          title: 'Are you sure Delete this?',
          text: "You won't be able to revert this!",
          icon: 'error',
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: 'Yes, delete it!'
        }).then((result) => {
          if (result.value) {
            axios.delete(salesUrl + '/opex/' + detail.id, { headers: getHeader() })
              .then(response => {
                this.sales.opexs.splice(index, 1)
              })
              .catch(error => {
                console.log(error.response)
              })
          }
        })
      }
    },
    addOpex: function () {
      var obj = {
        sale_no: null,
        amount: '0',
        opex_date: null,
        type: null,
        bank_id: null,
        user_id: null,
        notes: null,
        state: 'create'
      }
      this.sales.opexs.push(obj)
    },
    toProject: function (id) {
      this.$router.push({ name: 'project', query: { id: id, ref: this.sales.id } })
    },
    returDetail: function (value) {
      var detail = this.sales.details.find(d => d.id === value.idDetil)
      var newID = Math.floor(Math.random() * (99999999 - 66666666) + 66666666)
      var obj = {
        id: newID,
        sale_no: this.sales.sale_no,
        return_date: value.return_date,
        branch_no: this.sales.branch_no,
        product_no: detail.product_no,
        product: detail.product,
        products: detail.products,
        description: detail.description,
        internal_code: detail.barcode,
        qty: value.qty,
        qty_done: null,
        serial_number: value.serial_number,
        uom_id: detail.uom_id,
        price: detail.price,
        tax_id: detail.tax_id,
        tax: detail.tax,
        discount: detail.discount,
        total: value.qty * detail.price,
        queue: null,
        warehouse_no: detail.warehouse_no,
        reason: value.reason,
        uomList: detail.uomList,
        state: 'create'
      }
      console.log(obj)
      this.sales.returs.push(obj)
      if (value.change) {
        detail.qty = detail.qty - value.qty
        this.calcRow(detail.id)
        if (detail.qty <= 0) {
          this.removeDetail(value.idDetil)
        }
      }
    },
    async sendNotif (id) {
      var obj = {
        id: id
      }
      await axios.post(salesUrl + '/notif', obj, { headers: getHeader() })
        .then(response => {
          console.log(response.data.data)
          this.$swal(
            'Success',
            'Succes send notif to Whatsapp',
            'success'
          )
        })
        .catch(error => {
          console.log(error.response)
          this.$swal(
            'Error',
            'Cannot send notif',
            'error'
          )
        })
    },
    calcRowPrice: function (id) {
      var detail = this.sales.details.find(d => d.id === id)
      detail.total = parseFloat(detail.qty) * parseFloat(detail.price.replace(/\./g, ''))
    },
    uomRow (index) {
      var detail = this.sales.details[index]
      detail.price = 0
      detail.qty = 0
      detail.dicount = 0
      detail.tax = 0
      detail.total = 0
      var uom = detail.uomList.find(d => d.id === detail.uom_id)
      console.log(uom)
      var price = 0
      if (uom.category_id === 3) {
        price = parseFloat(uom.price)
      } else if (uom.category_id === 1) {
        price = parseFloat(uom.price) * parseFloat(uom.ratio)
      } else {
        price = parseFloat(uom.price) / parseFloat(uom.ratio)
      }
      detail.price = price.toString()
    },
    checkTax: function () {
      var cmp = this.companyList.find(d => d.company_no === this.sales.company_no)
      this.sales.tax_id = cmp.tax_id
      this.setTax()
    },
    calcRow (index) {
      var detail = this.sales.details[index]
      var qty = detail.qty
      var amount = parseFloat(detail.price.toString().replace(/\./g, ''))
      var order = this.sales.orders.find(d => d.order_no === detail.order_no)
      var qtyDone = 0
      if (order) {
        var orderDetail = order.details.find(d => d.product_no === detail.product_no)
        var orderPrice = orderDetail.price.replace(/\./g, '')
        qtyDone = orderDetail.qty
      }
      console.log(qty + '><' + qtyDone)
      console.log(amount + '><' + orderPrice)
      if (parseFloat(amount) === parseFloat(orderPrice)) {
        if (parseFloat(qty) > parseFloat(qtyDone)) {
          detail.qty = qtyDone
          this.$swal('Error', 'Quantity cannot greater than order', 'error')
          return false
        }
      }
      var discountPercentage = this.sales.details[index].discount_percentage === '' ? 0 : parseFloat(this.sales.details[index].discount_percentage)
      console.log(discountPercentage)
      var discount = amount * discountPercentage / 100
      var subtotal = amount - discount
      var tax = this.taxList.find(d => d.id === this.sales.tax_id)
      var dpp = 0
      var taxAmount = 0
      if (tax.include === false) {
        taxAmount = subtotal * tax.amount / 100
        dpp = subtotal
      } else {
        if (tax.amount === '0') {
          taxAmount = 0
          dpp = subtotal
        } else {
          if (tax.amount === '11') {
            dpp = subtotal / 1.11
            console.log('dpp: ' + Math.round(dpp))
            taxAmount = Math.round(dpp) * 0.11
            console.log('PPN:')
            console.log(taxAmount)
          } else {
            dpp = subtotal / 1.1
            taxAmount = Math.round(dpp) * 0.1
          }
        }
      }
      this.sales.details[index].discount = discount.toString()
      this.sales.details[index].subtotal = Math.round(dpp)
      this.sales.details[index].tax = Math.round(taxAmount)
      var totalDetailRow = (this.sales.details[index].subtotal + this.sales.details[index].tax) * qty
      this.sales.details[index].total = totalDetailRow
      console.log('Total: ' + totalDetailRow)
      // this.sales.details[index].subtotal = dpp
      // this.sales.details[index].tax = taxAmount
      // this.sales.details[index].total = (dpp + taxAmount) * qty

      this.sales.discount = this.totalDetailDiscount
      this.sales.subtotal = this.totalDetailSubtotal
      this.sales.tax = this.getTotalTax
      this.sales.total = this.getTotalDPP + this.getTotalTax
    },
    setTotalDiscount: function () {
      var array = this.sales.details
      var sum = 0
      for (let i = 0; i < array.length; i++) {
        // sum += parseFloat(array[i].discount) * parseFloat(array[i].qty)
        sum += parseFloat(array[i].discount.replace(/\./g, '')) * parseFloat(array[i].qty)
      }
      return sum.toString()
    },
    setTotalTax () {
      var array = this.sales.details
      var sum = 0
      for (let i = 0; i < array.length; i++) {
        console.log('tax detail: ' + array[i].tax)
        // sum += parseFloat(array[i].discount) * parseFloat(array[i].qty)
        if (isNaN(array[i].tax)) {
          sum += parseFloat(array[i].tax) * parseFloat(array[i].qty)
        } else {
          sum += array[i].tax * parseInt(array[i].qty)
        }
      }
      return sum.toString()
    },
    setIdDetail: function (id) {
      this.idDetail = id
      var payload = {
        date: this.sales.sale_date
      }
      this.$store.dispatch('getProductWithTotal', payload)
      // this.getType()
    },
    setIdDetailRetur: function (id) {
      this.detail = this.sales.details.find(d => d.id === id)
      console.log(this.detail)
    },
    async selectProduct (value) {
      this.$Progress.start()
      this.loader.isLoading = true
      var dtl = this.sales.details.find(d => d.product_no === value.product_no)
      if (dtl) {
        this.$swal('Error', 'Product already pick in detail', 'error')
        return false
      }
      var data = {
        product_no: value.product_no,
        date: this.sales.sale_date
      }
      await axios.post(productUrl + '/latest-price', data, { headers: getHeader() })
        .then(response => {
          console.log(response.data.message)
          var product = response.data.data
          var amount = parseFloat(product.price)
          var subtotal = amount
          var dpp = 0
          var tax = this.taxList.find(d => d.id === this.sales.tax_id)
          var taxAmount = 0
          if (tax.include === false) {
            taxAmount = subtotal * tax.amount / 100
            dpp = subtotal
          } else {
            if (tax.amount === '0') {
              taxAmount = 0
              dpp = subtotal
            } else {
              taxAmount = subtotal * (tax.amount / 100)
              dpp = subtotal - taxAmount
            }
          }
          var detail = this.sales.details[this.idDetail]
          detail.sale_no = this.sales.sale_no
          detail.branch_no = this.sales.branch_no
          detail.product_no = product.product_no
          detail.description = product.product_name
          detail.internal_code = product.barcode
          detail.qty = 1
          detail.serial_number = null
          detail.uom_id = product.uom_id
          detail.price = product.price.toString()
          detail.tax_id = this.sales.tax_id
          detail.tax = taxAmount
          detail.discount = '0'
          detail.discount_percentage = '0'
          detail.subtotal = dpp
          detail.total = (dpp + taxAmount) * detail.qty
          detail.state = 'create'
          detail.uomList = product.uomList
          detail.warehouse_no = this.sales.warehouse_no
          detail.cost = '0'
          detail.cost_id = product.cost_id
          this.setTax()
          this.$Progress.finish()
          this.loader.isLoading = false
        })
        .catch(error => {
          console.log(error.response)
          this.$swal('Error', error.response.data.message, 'error')
          this.$Progress.finish()
          this.loader.isLoading = false
        })
      var body = {
        product_no: value.product_no
      }
      await axios.post(productUrl + '/uom/list', body, { headers: getHeader() })
        .then(response => {
          console.log(response.data.message)
          var dt = this.sales.details[this.idDetail]
          dt.uomList = response.data.data
          dt.uom_id = value.uom_id
        })
    },
    async printInvoice (status) {
      if (this.sales.lock === false) {
        await this.approveSales()
        await this.setCOGSAll('no reply')
        await this.setJournalAll()
      }
      if (status === 'invoice') {
        console.log(sale2Url + '/print/' + this.sales.id)
        window.open(sale2Url + '/print/' + this.sales.id, '_blank')
      } else if (status === 'bstk') {
        window.open(sale2Url + '/print/' + this.sales.id + '/bstk', '_blank')
      }
    },
    async print () {
      this.$Progress.start()
      this.loader.isLoading = true
      var data = {
        id: this.sales.id,
        format: null,
        data: this.groupDetail
      }
      if (data.length === 0) {
        this.$swal('Error', 'Data masih kosong', 'error')
        return false
      }
      console.log(data)
      await axios.post(sale2Url + '/invoice2', data, { responseType: 'blob' })
        .then(response => {
          const objectUrl = URL.createObjectURL(response.data)
          console.log('Showing PDF...')
          window.open(objectUrl, '_blank')
          this.$Progress.finish()
          this.loader.isLoading = false
        })
        .catch(error => {
          this.$Progress.finish()
          this.loader.isLoading = false
          console.log(error)
          console.log(error.response)
        })
    },
    getInput: function () {
      this.sales.payments[0].price = this.getTotal.replace(/\./g, '')
    },
    async onBarcodeScanned (barcode) {
      console.log('has listener ' + this.$barcodeScanner.hasListener())
      var obj = {
        barcode: barcode
      }
      console.log(barcode)
      await axios.post(productUrl + '/scan/barcode', obj, { headers: getHeader() })
        .then(response => {
          console.log(response.data.data)
          const product = response.data.data
          var productDetail = this.sales.details.find(d => d.product_no === product.product_no)
          if (productDetail) {
            productDetail.qty = parseInt(productDetail.qty) + 1
            productDetail.total = parseInt(productDetail.qty) * parseFloat(productDetail.price.replace(/\./g, ''))
          } else {
            // const price = product.productGet.uomList.find(d => d.category_id === 3)
            var obj = {
              id: Math.floor(Math.random() * (99999999 - 66666666) + 66666666),
              product_no: product.product_no,
              product: product.productGet.product_name,
              description: product.productGet.product_description,
              qty: 1,
              uom_id: product.productGet.uom_id,
              price: product.price,
              tax_id: null,
              tax: '0',
              discount: '0',
              total: product.price,
              edit: false,
              uomList: product.productGet.uomList
            }
            this.sales.details.push(obj)
          }
        })
        .catch(error => {
          console.log(error.response)
        })
    },
    getCustomerList: function () {
      this.$store.dispatch('getCustomerList')
    },
    createCustomer: function (customer) {
      this.sales.customer_no = customer.customer_no
      this.sales.customer = customer
    },
    salesPayment: function () {
      this.$emit('onPayment', this.sales)
    },
    createBastk: function () {
      // this.$emit('onBstk', this.sales)
      const id = this.sales.id
      this.$router.push({ name: 'sales-bstk', params: { id } })
    },
    setTax: function () {
      var array = this.sales.details
      for (let i = 0; i < array.length; i++) {
        this.calcRow(i)
      }
    },
    detailClear: function () {
      var array = this.sales.details
      for (let i = 0; i < array.length; i++) {
        // array[i].edit = false
      }
    },
    backParent: function () {
      this.alert = []
      this.$emit('backClicked')
    },
    async syncOrderAll (reply) {
      if (reply === 'reply') {
        await this.$Progress.start()
        this.loader.isLoading = true
      }
      var array = this.sales.orders
      for (let i = 0; i < array.length; i++) {
        var arr = array[i].details
        for (let a = 0; a < arr.length; a++) {
          var obj = {
            product_no: arr[a].product_no,
            order_no: arr[a].order_no,
            price: arr[a].price,
            uom_id: arr[a].uom_id
          }
          await axios.post(saleOrderUrl + '/sync-to-sales', obj, { headers: getHeader() })
            .then(response => {
              console.log(response.data.message)
            })
            .catch(error => {
              console.log(error)
              console.log(error.response.data.message)
              this.alert.push(error.response.data.message)
            })
        }
      }
      if (reply === 'reply') {
        await this.$Progress.finish()
        this.loader.isLoading = false
      }
    },
    async syncOrder2 (reply) {
      await this.$Progress.start()
      this.loader.isLoading = true
      var array = this.salesDetail
      for (let i = 0; i < array.length; i++) {
        var obj = {
          product_no: array[i].product_no,
          order_no: array[i].order_no,
          price: array[i].price.replace(/\./g, ''),
          uom_id: array[i].uom_id
        }
        var resp = {
          error: false,
          message: null
        }
        console.log(obj)
        await axios.post(saleOrderUrl + '/sync-to-sales', obj, { headers: getHeader() })
          .then(response => {
            console.log(response.data.message)
            resp.error = false
            resp.message = response.data.message
          })
          .catch(error => {
            console.log(error)
            console.log(error.response)
            this.$Progress.fail()
            this.loader.isLoading = false
            if (reply === 'reply') {
              this.$swal('Error', error.response.data.message, 'error')
              throw error
            }
            resp.error = true
            resp.message = error.response.data.message
          })
      }
      await this.$Progress.finish()
      this.loader.isLoading = false
      if (reply === 'reply') {
        if (resp.error === true) {
          await this.$swal('Error', resp.message, 'error')
        } else {
          await this.$swal('Success', resp.message, 'success')
        }
      }
    },
    async syncOrder () {
      var dataSync = {
        date: this.sales.sale_date,
        customer_no: this.sales.customer_no
      }
      await axios.post(salesUrl + '/order/sync-product', dataSync, { headers: getHeader() })
        .then(response => {
          this.$swal('Success', response.data.message, 'success')
          this.$emit('backParentID', this.sales.id)
        })
        .catch(error => {
          console.log(error)
          this.$swal(
            'Error',
            error.response.data.message,
            'error'
          )
          return false
        })
    },
    async updateSales () {
      const validate = this.validateDetail()
      if (validate === false) {
        return false
      } else {
        this.$Progress.start()
        this.loader.isLoading = true
      }
      await this.refreshCalc()
      var status = null
      if (this.getRemaining > 0) {
        status = 'outstanding'
      } else {
        status = 'completed'
      }
      var warehouse = this.warehouseList.find(d => d.company_no === this.sales.company_no)
      var dataDeliver = []
      dataDeliver.push(this.deliveryData)
      this.data = {
        sale_no: null,
        sale_date: this.sales.sale_date,
        sale_due_date: this.sales.sale_due_date,
        type_id: this.sales.type_id,
        customer_no: this.sales.customer_no,
        branch_no: this.sales.branch_no,
        warehouse_no: warehouse ? warehouse.warehouse_no : null,
        subtotal: this.getSubtotal,
        tax_id: this.sales.tax_id,
        tax: this.sales.tax,
        discount: this.sales.discount,
        total: this.sales.total,
        delivery_cost: 0,
        deliver_no: null,
        salesman_id: this.sales.salesman_id,
        salesman: null,
        status: status,
        notes: this.sales.notes,
        price_id: this.sales.price_id,
        company_no: this.sales.company_no,
        term_due_id: this.sales.term_due_id,
        orders: this.sales.orders,
        deliveries: dataDeliver
      }
      var dataSales = {}
      console.log('data sales')
      console.log(this.data)
      await axios.put(salesUrl + '/' + this.sales.id, this.data, { headers: getHeader() })
        .then(response => {
          dataSales = response.data.data
          console.log('data sales')
          console.log(dataSales)
        })
        .catch(error => {
          console.log(error.response)
          this.$swal('Error', error.response.data.message, 'error')
          return false
        })
      var array = this.salesDetail
      for (let i = 0; i < array.length; i++) {
        if (array[i].product_no !== null || array[i].product_no !== '') {
          var obj = {}
          if (typeof array[i].id === 'undefined') {
            obj = {
              sale_no: dataSales.sale_no,
              sale_date: dataSales.sale_date,
              branch_no: dataSales.branch_no,
              product_no: array[i].product_no,
              product_sku: array[i].product_sku,
              description: array[i].description,
              qty: array[i].qty,
              serial_number: array[i].serial_number,
              uom_id: array[i].uom_id,
              price: array[i].price.replace(/\./g, ''),
              tax_id: array[i].tax_id,
              tax: array[i].tax,
              discount: array[i].discount,
              discount_percentage: array[i].discount_percentage == null ? 0 : array[i].discount_percentage,
              subtotal: array[i].subtotal,
              total: array[i].total,
              queue: array[i].queue,
              warehouse_no: array[i].warehouse_no === null ? warehouse.warehouse_no : array[i].warehouse_no,
              internal_code: array[i].internal_code,
              cost: null,
              cost_id: null,
              sec_serial_number: array[i].sec_serial_number,
              company_no: this.sales.company_no,
              order_no: array[i].order_no
            }
          } else {
            obj = {
              id: array[i].id,
              sale_no: dataSales.sale_no,
              sale_date: dataSales.sale_date,
              branch_no: dataSales.branch_no,
              product_no: array[i].product_no,
              product_sku: array[i].product_sku,
              description: array[i].description,
              qty: array[i].qty,
              serial_number: array[i].serial_number,
              uom_id: array[i].uom_id,
              price: array[i].price.replace(/\./g, ''),
              tax_id: array[i].tax_id,
              tax: array[i].tax,
              discount: array[i].discount,
              discount_percentage: array[i].discount_percentage == null ? 0 : array[i].discount_percentage,
              subtotal: array[i].subtotal,
              total: array[i].total,
              queue: array[i].queue,
              warehouse_no: array[i].warehouse_no === null ? warehouse.warehouse_no : array[i].warehouse_no,
              internal_code: array[i].internal_code,
              cost: null,
              cost_id: null,
              sec_serial_number: array[i].sec_serial_number,
              company_no: this.sales.company_no,
              order_no: array[i].order_no
            }
          }
          console.log(obj)
          await axios.post(salesUrl + '/detail', obj, { headers: getHeader() })
            .then(response => {
              console.log(response.data.message)
            })
            .catch(error => {
              console.log(error.response)
            })
          var bodyDelivery = {
            sale_no: dataSales.sale_no,
            serial_number: null,
            sec_serial_number: null,
            product_no: array[i].product_no
          }
          console.log('bodyDelivery')
          console.log(bodyDelivery)
          await axios.post(salesUrl + '/delivery/detail', bodyDelivery, { headers: getHeader() })
            .then(response => {
              console.log(response.data.message)
            })
            .catch(error => {
              console.log(error.response)
            })
        }
      }
      await this.syncOrderAll('no reply')
      await this.setCOGSAll('no reply')
      await this.$Progress.finish()
      this.loader.isLoading = false
      await this.$swal('Success', 'Success update sales and order', 'success')
      await this.$emit('backClicked')
      this.alert = []
    },
    async validateDetailProduct () {
      this.alert = []
      var array = this.sales.details
      for (let i = 0; i < array.length; i++) {
        const stockSale = parseFloat(array[i].qty)
        var gpm = this.groupDetailColl.find(d => d.product_no === array[i].product_no)
        var qtyExist = gpm ? gpm.qty : '0'
        if (stockSale > 0) {
          var obj = {
            product_no: array[i].product_no,
            date: this.sales.sale_date
          }
          var url = productUrl + '/cost/get-saldo'
          await axios.post(url, obj, { headers: getHeader() })
            .then(response => {
              const stockQty = parseFloat(response.data.data.qty)
              var qtySaldo = stockQty + parseFloat(qtyExist)
              if (qtySaldo === 0) {
                this.alert.push('Stock <strong>[' + array[i].product_no + ']</strong> ' + ' Saldo stock kurang = (' + stockQty + ')')
              } else {
                console.log('Remaining ' + array[i].product_no + ' ' + stockQty + '+ ' + qtyExist + ' = ' + qtySaldo)
                var qtyRemaining = qtySaldo - stockSale
                if (qtyRemaining < 0) {
                  this.alert.push('Stock <strong>[' + array[i].product_no + ']</strong> ' + ' Saldo stock kurang = (' + qtySaldo + ')')
                }
              }
            })
            .catch(error => {
              console.log(error)
              console.log(error.response)
              this.$swal('Error', error.response.data.message, 'error')
              throw error
            })
        } else {
          this.alert.push('Stock <strong>[' + array[i].product_no + ']</strong> ' + array[i].description + ' qty stock tidak boleh kosong')
        }
        if (array[i].uom_id === null) {
          this.alert.push('Stock <strong>[' + array[i].product_no + ']</strong> ' + array[i].description + ' uom tidak boleh kosong')
        }
      }
      if (this.sales.customer_no === null) {
        this.alert.push('<b>Customer</b> harus diinput terlebih dahulu')
      }
      if (this.sales.salesman_id === null) {
        this.alert.push('<b>Salesman</b> harus diinput terlebih dahulu')
      }
      if (this.sales.tax_id === null) {
        this.alert.push('<b>Tax</b> harus diinput terlebih dahulu')
      }
      if (this.sales.company_no === null) {
        this.alert.push('<b>Company</b> harus diinput terlebih dahulu')
      }
      var total = parseFloat(this.sales.total)
      if (total === 0) {
        this.alert.push('<b>Total</b> masih kosong, cek kembali inputan product')
      }
      var arr = this.sales.details
      var result = []
      var resultProductNo = []
      var resultProductUom = []
      arr.reduce(function (res, value) {
        // Check product_no null & duplicate
        if (value.product_no !== null) {
          var price = value.price.replace(/\./g, '')
          var key = value.product_no + price + value.order_no
          console.log(key)
          if (!res[key]) {
            res[key] = {
              id: key,
              product_no: value.product_no,
              price: parseFloat(price).toLocaleString('id-ID')
            }
          } else {
            result.push({
              id: key,
              product_no: value.product_no,
              price: parseFloat(price).toLocaleString('id-ID')
            })
          }
          // check uom null
          if (value.uom_id === null) {
            resultProductUom.push({
              id: value.id + 'uom',
              product_no: value.product_no
            })
          }
          if (value.product_no === null) {
            resultProductNo.push({
              id: res
            })
          }
        } else {
          resultProductNo.push({
            id: res
          })
        }
        return res
      }, {})
      if (result.length > 0) {
        for (let i = 0; i < result.length; i++) {
          this.alert.push('Duplicate Product & Price (<b>' + result[i].product_no + ' | ' + result[i].price + '</b>)')
        }
      }
      if (resultProductUom.length > 0) {
        for (let z = 0; z < resultProductUom.length; z++) {
          this.alert.push('<b>Uom</b> cannot be null ' + resultProductUom[z].product_no)
        }
      }
      if (resultProductNo.length > 0) {
        var msg = {}
        for (let h = 0; h < resultProductNo.length; h++) {
          msg = '<b>Product</b> harus diinput terlebih dahulu (tidak boleh kosong)'
        }
        this.alert.push(msg)
      }
    },
    validateDetail () {
      var array = this.sales.details
      var loop = []
      var resp = {
        error: false,
        message: null,
        data: []
      }
      for (let i = 0; i < array.length; i++) {
        if (array[i].uom_id === null) {
          var ob = {
            product_no: array[i].product_no
          }
          resp = {
            error: true,
            message: 'Uom harus diisi'
          }
          resp.data.push(ob)
        } else if (array[i].qty === null || array[i].qty === 0 || array[i].qty === '0') {
          var ob2 = {
            product_no: array[i].product_no
          }
          console.log(ob2)
          loop.push(ob2)
          resp = {
            error: true,
            message: 'Qty tidak boleh 0',
            data: loop
          }
        }
      }
      console.log('response validate')
      console.log(resp)
      if (resp.error === true) {
        var msg = resp.message
        var productMsg = ''
        for (let c = 0; c < resp.data.length; c++) {
          if (c === 0) {
            productMsg = resp.data[c].product_no
          } else {
            productMsg = productMsg + ' ,' + resp.data[c].product_no
          }
        }
        this.$swal('Error', msg + '[' + productMsg + ']', 'error')
        return false
      } else {
        return true
      }
    },
    async createSales () {
      await this.validateDetailProduct()
      if (this.alert.length > 0) {
        window.scrollTo(0, 0)
        this.$swal('Error', 'Data tidak valid, cek terlebih dahulu', 'error')
        return false
      } else {
        this.$Progress.start()
        this.loader.isLoading = true
      }
      await this.refreshCalc()
      var warehouse = this.warehouseList.find(d => d.company_no === this.sales.company_no)
      var dataDeliver = []
      dataDeliver.push(this.deliveryData)
      this.data = {
        sale_no: null,
        sale_date: this.sales.sale_date,
        sale_due_date: this.sales.sale_due_date,
        type_id: this.sales.type_id,
        customer_no: this.sales.customer_no,
        branch_no: this.sales.branch_no,
        warehouse_no: warehouse ? warehouse.warehouse_no : null,
        subtotal: this.getSubtotal,
        tax_id: this.sales.tax_id,
        tax: this.sales.tax,
        discount: this.sales.discount,
        total: this.sales.total,
        delivery_cost: 0,
        deliver_no: null,
        salesman_id: this.sales.salesman_id,
        salesman: null,
        price_id: this.sales.price_id,
        company_no: this.sales.company_no,
        term_due_id: this.sales.term_due_id,
        orders: this.sales.orders,
        deliveries: dataDeliver,
        lock: false,
        status: 'Open',
        notes: this.sales.notes
      }
      var dataSales = {}
      await axios.post(salesUrl, this.data, { headers: getHeader() })
        .then(response => {
          dataSales = response.data.data
        })
        .catch(error => {
          console.log(error.response)
          this.$swal('Error', error.response.data.message, 'error')
          return false
        })
      var array = this.sales.details
      for (let i = 0; i < array.length; i++) {
        if (array[i].product_no !== null || array[i].product_no !== '') {
          var obj = {
            sale_no: dataSales.sale_no,
            sale_date: dataSales.sale_date,
            branch_no: dataSales.branch_no,
            product_no: array[i].product_no,
            product_sku: array[i].product_sku,
            description: array[i].description,
            qty: array[i].qty,
            serial_number: array[i].serial_number,
            uom_id: array[i].uom_id,
            price: array[i].price.replace(/\./g, ''),
            tax_id: array[i].tax_id,
            tax: array[i].tax,
            discount: array[i].discount,
            discount_percentage: array[i].discount_percentage == null ? 0 : array[i].discount_percentage,
            subtotal: array[i].subtotal,
            total: array[i].total,
            queue: array[i].queue,
            warehouse_no: array[i].warehouse_no === null ? warehouse.warehouse_no : array[i].warehouse_no,
            internal_code: array[i].internal_code,
            cost: null,
            cost_id: null,
            sec_serial_number: array[i].sec_serial_number,
            company_no: this.sales.company_no,
            order_no: array[i].order_no
          }
          await axios.post(salesUrl + '/detail', obj, { headers: getHeader() })
            .then(response => {
              console.log(response.data.message)
            })
            .catch(error => {
              console.log(error.response)
            })
          var bodyDelivery = {
            sale_no: dataSales.sale_no,
            serial_number: null,
            sec_serial_number: null,
            product_no: array[i].product_no
          }
          await axios.post(salesUrl + '/delivery/detail', bodyDelivery, { headers: getHeader() })
            .then(response => {
              console.log(response.data.message)
            })
            .catch(error => {
              console.log(error.response)
            })
          this.setQtyTotal(array[i].product_no)
        }
      }
      await this.$Progress.finish()
      this.loader.isLoading = false
      await this.setCOGSAll()
      await this.syncOrderAll('no reply')
      console.log(alert)
      if (this.alert.length > 0) {
        await this.$emit('backParentID', dataSales.id)
        this.alert = []
      } else {
        await this.$swal('Success', 'Success create sales', 'success')
        await this.$emit('backClicked')
        this.alert = []
      }
    },
    addNewLine: function () {
      // this.$store.dispatch('getProductList')
      // var newID = Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15)
      this.sales.details.push({
        sales_no: null,
        sale_date: null,
        branch_no: this.sales.branch_no,
        company_no: this.sales.company_no,
        product_no: null,
        product_sku: null,
        description: null,
        qty: '0',
        serial_number: null,
        sec_serial_number: null,
        uom_id: null,
        price: '0',
        tax_id: null,
        tax: '0',
        discount: '0',
        discount_percentage: '0',
        subtotal: '0',
        total: '0',
        queue: '1',
        warehouse_no: this.sales.warehouse_no,
        state: 'create',
        edit: false,
        uomList: [{
          id: null,
          name: null,
          category_id: null,
          type_id: null,
          ratio: null,
          active: null
        }],
        cost: '0',
        cost_id: null,
        margin: '0',
        margin_percentage: '0',
        internal_code: null
      })
      this.state = 'create'
      // sales type
      // var styp = this.salesTypeList.find(d => d.id === this.sales.type_id)
      // var obj = {
      //   salesType: styp.name
      // }
      // this.$store.dispatch('getProductByPriceList', obj)
    },
    editDetail: function (id) {
      // var p = this.sales.details.find(d => d.id === id)
      this.idDetail = id
      // sales type
      // var styp = this.salesTypeList.find(d => d.id === this.sales.type_id)
      // var obj = {
      //   salesType: styp.name
      // }
      // this.$store.dispatch('getProductByPriceList', obj)
    },
    async removeDetail (index) {
      var detail = this.sales.details[index]
      var orderNo = detail.order_no
      this.calcRow(0)
      if (typeof detail.id === 'undefined') {
        this.sales.details.splice(index, 1)
        this.calcRow(0)
      } else {
        this.$swal.fire({
          title: 'Are you sure Delete this?',
          text: "You won't be able to revert this!",
          icon: 'error',
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: 'Yes, delete it!'
        }).then((result) => {
          if (result.value) {
            axios.delete(salesDetailUrl + '/' + detail.id, { headers: getHeader() })
              .then(response => {
                console.log(response.data.message)
                this.calcRow(0)
                var data = {
                  date: this.sales.sale_date,
                  product_no: detail.product_no,
                  type: 'all',
                  company_no: null
                }
                console.log(data)
                axios.post(productUrl + '/cost/sync', data, { headers: getHeader() })
                  .then(response => {
                    console.log(response.data.message)
                  })
                  .catch(error => {
                    console.log(error)
                    console.log(error.response)
                  })
                this.sales.details.splice(index, 1)
                var orderDetail = this.sales.details.filter(d => d.order_no === orderNo)
                if (orderDetail.length === 0) {
                  const orderID = this.sales.orders.findIndex(d => d.order_no === orderNo)
                  this.sales.orders.splice(orderID, 1)
                }
              })
              .catch(error => {
                console.log(error.response)
              })
          }
        })
      }
    },
    deleteRetur (id) {
      var retur = this.sales.returs.find(d => d.id === id)
      var qty = retur.qty
      var detail = this.sales.details.find(d => d.product_no === retur.product_no)
      var index = this.sales.returs.findIndex(d => d.id === id)
      if (retur.state === 'create') {
        detail.qty = parseInt(detail.qty) + parseInt(qty)
        this.sales.returs.splice(index, 1)
      } else {
        this.$swal.fire({
          title: 'Are you sure Delete this?',
          text: "You won't be able to revert this!",
          icon: 'error',
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: 'Yes, delete it!'
        }).then((result) => {
          if (result.value) {
            axios.delete(salesReturUrl + '/' + retur.id, { headers: getHeader() })
              .then(response => {
                detail.qty = parseInt(detail.qty) + parseInt(qty)
                this.sales.returs.splice(index, 1)
              })
              .catch(error => {
                console.log(error.response)
              })
          }
        })
      }
    },
    async selectCustomerList (customer) {
      this.sales.customer_no = customer.customer_no
      this.sales.customer = customer
      this.sales.term_due_id = customer.term_due_id
      var data = {
        customer_no: customer.customer_no
      }
      await axios.post(salesUrl + '/get-latest-sales', data, { headers: getHeader() })
        .then(response => {
          var sales = response.data.data
          if (this.sales.term_due_id === null) {
            this.sales.term_due_id = sales.term_due_id
          }
          this.sales.salesman_id = sales.salesman_id
        })
        .catch(error => {
          console.log(error.response)
          // this.$swal('Error', error.response.data.message, 'error')
        })
    }
  }
}
</script>

<style>
  .flex {
    display: flex;
    flex-direction: row;
  }
  .text-style {
    color: #28A745;
  }
</style>
